// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__3s3J5","centeredSpinner":"LoadingSpinner_centeredSpinner__b6_In"};